import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { StatusDropdownComponent, StatusValue } from '../../molecules';
import { ThemedIconComponent } from '../../atoms';

export interface StatusSelectionDialogData {
  title: string;
  value?: StatusValue;
  placeholder?: string;
  ariaLabel?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'ocp-status-selection-dialog',
  imports: [HlmButtonImports, StatusDropdownComponent, ThemedIconComponent, TranslatePipe],
  templateUrl: './status-selection-dialog.component.html',
  styleUrl: './status-selection-dialog.component.scss',
})
export class StatusSelectionDialogComponent {
  private readonly dialogRef = inject<BrnDialogRef<StatusValue | undefined>>(BrnDialogRef, {
    optional: true,
  });
  private readonly dialogContext = injectBrnDialogContext<StatusSelectionDialogData>({
    optional: true,
  });

  protected readonly data: StatusSelectionDialogData = {
    title: this.dialogContext?.title ?? '',
    value: this.dialogContext?.value ?? null,
    placeholder: this.dialogContext?.placeholder ?? '',
    ariaLabel: this.dialogContext?.ariaLabel ?? '',
    confirmLabel: this.dialogContext?.confirmLabel ?? 'Ok',
    cancelLabel: this.dialogContext?.cancelLabel ?? 'Cancel',
  };

  protected readonly selectedValue = signal<StatusValue>(this.data.value ?? null);

  protected onStatusChange(value: StatusValue): void {
    this.selectedValue.set(value);
  }

  protected onConfirm(): void {
    if (!this.selectedValue()) {
      return;
    }

    this.dialogRef?.close(this.selectedValue());
  }

  protected onCancel(): void {
    this.dialogRef?.close();
  }
}
